// API =>
import backEnd from "../../services/Api"

// utils =>
import { FetchCSRF } from "../../utils/GetCSRF";
import { LocalCSRFReceiver } from "../../utils/GetLocalCSRF";

// type =>
import { PRODUCT_BOX_SERVICE_RESPONSE_TYPE } from "./productBoxType";

export const AddProductToCart = async (productCode: number, colorId: number, itemVariant: number): Promise<PRODUCT_BOX_SERVICE_RESPONSE_TYPE> => {
    const csrf = await LocalCSRFReceiver()

    let resultStatus: boolean = false;
    let resultMessage: string = "";

    await backEnd.post(
        "shopping-cart/items/add/",
        {
            product_id: productCode,
            item_color: colorId,
            item_variant: itemVariant,
            quantity: 1,
        },
        {
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": csrf,
            },
        }).then(( result ) => {
            resultStatus = true;
            resultMessage = "تعداد محصول با موفقیت در سبد خرید شما افزایش یافت";
        }).catch(( error ) => {
            switch (error.status) {
                case 400:
                    resultMessage = "درخواست نامعتبر است.";
                    break;
                case 401:
                    resultMessage = "لطفاً وارد حساب کاربری خود شوید.";
                    break;
                case 403:
                    resultMessage = "دسترسی شما محدود شده است.";
                    break;
                case 404:
                    resultMessage = "محصول یافت نشد.";
                    break;
                case 429:
                    resultMessage = "تعداد درخواست‌ها بیش از حد مجاز است.";
                    break;
                case 500:
                    resultMessage = "خطای داخلی سرور رخ داده است.";
                    break;
                default:
                    resultMessage = "خطایی رخ داده است.";
                    break;
            }
        });

    return {
        success: resultStatus,
        message: resultMessage,
    };
}

export const RemoveProductFromCart = async (productCode: number, colorId: number, itemVariant: number): Promise<PRODUCT_BOX_SERVICE_RESPONSE_TYPE> => {
    const csrf = await LocalCSRFReceiver();

    let resultStatus: boolean = false;
    let resultMessage: string = "";

    await backEnd.post(
        "shopping-cart/items/add/",
        {
            product_id: productCode,
            item_color: colorId,
            item_variant: itemVariant,
            quantity: -1,
        },
        {
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": csrf,
            },
        }).then(( result ) => {
            resultStatus = true;
            resultMessage = "تعداد محصول با موفقیت در سبد خرید شما کاهش یافت";
        }).catch(( error ) => {
            switch (error.status) {
                case 400:
                    resultMessage = "درخواست نامعتبر است.";
                    break;
                case 401:
                    resultMessage = "لطفاً وارد حساب کاربری خود شوید.";
                    break;
                case 403:
                    resultMessage = "دسترسی شما محدود شده است.";
                    break;
                case 404:
                    resultMessage = "محصول یافت نشد.";
                    break;
                case 429:
                    resultMessage = "تعداد درخواست‌ها بیش از حد مجاز است.";
                    break;
                case 500:
                    resultMessage = "خطای داخلی سرور رخ داده است.";
                    break;
                default:
                    resultMessage = "خطایی رخ داده است.";
                    break;
            };
        });

    return {
        success: resultStatus,
        message: resultMessage,
    };
}

export const DeleteProductFromCart = async (productKey: number): Promise<PRODUCT_BOX_SERVICE_RESPONSE_TYPE> => {
    const csrf = await LocalCSRFReceiver();

    let resultStatus: boolean = false;
    let resultMessage: string = "";

    await backEnd.delete(
        `shopping-cart/items/${ productKey }/remove/`,
        {
            headers: {
                "X-CSRFToken": csrf
            }
        }).then(( result ) => {
            resultStatus = true;
            resultMessage = "محصول با موفقیت از سبد خرید حذف شد";
        }).catch(( error ) => {
            switch (error.status) {
                case 400:
                    resultMessage = "درخواست نامعتبر است.";
                    break;
                case 401:
                    resultMessage = "لطفاً وارد حساب کاربری خود شوید.";
                    break;
                case 403:
                    resultMessage = "دسترسی شما محدود شده است.";
                    break;
                case 404:
                    resultMessage = "محصول یافت نشد.";
                    break;
                case 429:
                    resultMessage = "تعداد درخواست‌ها بیش از حد مجاز است.";
                    break;
                case 500:
                    resultMessage = "خطای داخلی سرور رخ داده است.";
                    break;
                default:
                    resultMessage = "خطایی رخ داده است.";
                    break;
            }
        });

    return {
        success: resultStatus,
        message: resultMessage,
    };
}
